export const API_JOIN_URL = '/api/v1/webinar/join?';
export const WAITING_FOR_SPEAKER_TIMEOUT = 10000;
